import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL1 } from "../utils/apiURL";
import { STATUS } from "../utils/status";

const initialState = {
    vendors: [],
    vendorsStatus: STATUS.IDLE,
    vendorProducts: [], // État pour stocker les produits d'un vendeur spécifique
    vendorProductsStatus: STATUS.IDLE,
};

const vendorSlice = createSlice({
    name: 'vendor',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAsyncVendors.pending, (state) => {
                state.vendorsStatus = STATUS.LOADING;
            })
            .addCase(fetchAsyncVendors.fulfilled, (state, action) => {
                state.vendors = action.payload;
                state.vendorsStatus = STATUS.SUCCEEDED;
            })
            .addCase(fetchAsyncVendors.rejected, (state) => {
                state.vendorsStatus = STATUS.FAILED;
            })
            .addCase(fetchAsyncVendorProducts.pending, (state) => {
                state.vendorProductsStatus = STATUS.LOADING;
            })
            .addCase(fetchAsyncVendorProducts.fulfilled, (state, action) => {
                state.vendorProducts = action.payload;
                state.vendorProductsStatus = STATUS.SUCCEEDED;
            })
            .addCase(fetchAsyncVendorProducts.rejected, (state) => {
                state.vendorProductsStatus = STATUS.FAILED;
            });
    }
});

// Async thunk to fetch vendors
export const fetchAsyncVendors = createAsyncThunk('vendors/fetch', async () => {
    const response = await fetch(`${BASE_URL1}get/VendorList`);
    if (!response.ok) throw new Error("Network response was not ok");
    const data = await response.json();
    return data.employees; // Assurez-vous que cela correspond à votre structure de données
});

// Async thunk to fetch products for a specific vendor
export const fetchAsyncVendorProducts = createAsyncThunk('vendor-products/fetch', async (vendorId) => {
    const response = await fetch(`${BASE_URL1}products/vendor`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ vendorId }), // Envoi de vendorId dans le corps de la requête
    });
    if (!response.ok) throw new Error("Network response was not ok");
    const data = await response.json();
    return data.products; // Assurez-vous que cela correspond à votre structure de données
});

// Sélecteur pour obtenir un produit par ID
export const getVendorProductById = (state, productId) => {
    return state.vendor.vendorProducts.find(product => product.id === parseInt(productId));
};  

// Selectors
export const getAllVendors = (state) => state.vendor.vendors;
export const getVendorProducts = (state) => state.vendor.vendorProducts; // Sélecteur pour les produits d'un vendeur
export const getVendorsStatus = (state) => state.vendor.vendorsStatus;
export const getVendorProductsStatus = (state) => state.vendor.vendorProductsStatus; // Sélecteur pour le statut des produits d'un vendeur

export default vendorSlice.reducer;
